/**
 * Host-facing capabilities this editor build supports, advertised on
 * `editor.ready`.
 *
 * Hosts pin a specific editor version per product, so a host and the editor it
 * loads can be several releases apart. A host that gates a feature on its own
 * config alone will send messages an older editor silently drops, leaving the
 * customer with a control that does nothing. Advertising capabilities lets the
 * host fall back instead of dead-ending.
 *
 * Add an entry when a new host-driven surface ships, and never remove one while
 * a host may still be pinned to a version that relied on it.
 */
export enum EditorCapability {
  PERSONALIZATION_PRICING = 'personalizationPricing.v2',
  /** Multipack size × colour × quantity drawer driven by `batchSelection.*`. */
  BATCH_SELECTION = 'batchSelection',
  /** Text library sidebar tab (e.g. hymns) driven by `textLibrary.setEntries`. */
  TEXT_LIBRARY = 'textLibrary',
}

export const EDITOR_CAPABILITIES: EditorCapability[] = [
  EditorCapability.BATCH_SELECTION,
  EditorCapability.PERSONALIZATION_PRICING,
  EditorCapability.TEXT_LIBRARY,
];
